export default __webpack_public_path__ + "static/media/todo.aa87e92d.png";